import Container from '@atoms/Container';
import ArticleBlock from '@sections/ArticleBlock';
import ArticleCard from '@sections/ArticleCard';
import paddingDefault from '@utils/paddingDefault';
import React from 'react';
import Link from "../primitives/link";
import { colors } from '../primitives/colors';

const IndexMultiblogroll = ({ articles, isIndex, url }) => (
    <ul css={[styles.blogrollGrid, styles.blogrollGridIndex]}>
        {!!articles?.length
            && articles.map((article, index) => {
                if (index < 2) {
                    return (
                        <li css={styles.blogrollGridItem} key={article.title}>
                            {!!article?.title && <ArticleCard article={article} />}
                        </li>
                    );
                }
                return null;
            })}
        <li css={styles.blogrollGridItemDouble}>
            {!!articles?.length
                && articles.map((article, index) => {
                    if (index >= 2 && index <= 4) {
                        return (
                            <ArticleBlock
                                isMultiBlogroll
                                withImage={false}
                                isIndex={isIndex}
                                key={article.title}
                                article={article}
                            />
                        );
                    }
                    return null;
                })}
            {!!url && (
                <Link css={styles.link} to={url}>
                    See All Articles
                    {' '}
                    {'>'}
                </Link>
            )}
        </li>
    </ul>
);

const SingleMultiblogroll = ({ articles, isIndex, url }) => (
    <ul css={[styles.blogrollGrid, styles.blogrollGridNotIndex]}>
        <li css={styles.blogrollGridItem}>
            {!!articles?.length
                && articles.map(article => (
                    <ArticleBlock
                        withImage
                        isIndex={isIndex}
                        key={article.title}
                        article={article}
                    />
                ))}
            {!!url && (
                <Link css={styles.link} to={url}>
                    See All Articles
                    {' '}
                    {'>'}
                </Link>
            )}
        </li>
    </ul>
);

const MultiBlogrollAlt = ({ data }) => {
    const { subblog: subblogs, isIndex } = data || { subblog: [], isIndex: false };

    return (
        <section css={paddingDefault()}>
            <Container css={styles.container}>
                {!!subblogs
                    && subblogs.map((subroll) => {
                        const { heading: title, url, articles } = subroll;

                        if (!articles) {
                            return null;
                        }

                        return (
                            <div css={styles.blogrollGridWrapper} key={title}>
                                {!!title && (
                                    <Link to={url}>
                                        <h2 css={[styles.blogrollHeading, isIndex ? styles.blogrollHeadingIndex : styles.blogrollHeadingNotIndex]} isIndex={isIndex}>{title}</h2>
                                    </Link>
                                )}
                                {isIndex ? (
                                    <IndexMultiblogroll
                                        articles={articles}
                                        isIndex={isIndex}
                                        url={url}
                                    />
                                ) : (
                                    <SingleMultiblogroll
                                        articles={articles}
                                        isIndex={isIndex}
                                        url={url}
                                    />
                                )}
                            </div>
                        );
                    })}
            </Container>
        </section>
    );
};

const styles = {
    container: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    blogrollHeading: {
        paddingBottom: "0.5rem",
        marginBottom: "0.5rem",
        fontSize: "1.125rem",
        lineHeight: "1.75rem",
        fontWeight: 500,
        "@media (min-width: 1024px)": {
            marginBottom: "2.5rem",
            fontSize: "1.5rem",
            lineHeight: "2rem",
        },
    },
    blogrollHeadingIndex: {
        borderBottomWidth: "2px",
        borderColor: colors.primaryOrange,
        color: colors.primaryOrange,
    },
    blogrollHeadingNotIndex: {
        textAlign: "center",
        "@media (min-width: 1024px)": {
            marginBottom: "1rem",
            fontSize: "1.875rem",
            lineHeight: "2.25rem",
        }
    },
    blogrollGridWrapper: {
        marginBottom: "1rem",
        width: "100%",
        "@media (min-width: 1024px)": { 
            marginBottom: "4rem" ,
        }
    },
    blogrollGridItem: {
        marginBottom: "1.5rem",
        flex: "1 1 auto",
        width: "100%",
        "@media (min-width: 768px)": {
            marginBottom: "0",
        }
    },
    blogrollGridItemDouble: {
        "@media (min-width: 1024px)": {
            gridColumn: "3 / 5",
        }
    },
    blogrollGrid: {
        paddingTop: "1rem",
        paddingBottom: "2.5rem",
    },
    blogrollGridNotIndex: {
        display: "flex",
        flexDirection: "column",
    },
    blogrollGridIndex: {

        "@media (min-width: 768px)": {
            display: "grid",

            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: "1.5rem",
            rowGap: "4rem",
        },
        "@media (min-width: 1024px)": {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        }
    },
    link: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        fontWeight: 500,
        color: "#000000",
    }
};

export default MultiBlogrollAlt;
